import type { MailboxInfo } from 'owa-client-types';
import type { ApplicationSettingGroup, ApplicationSettings } from 'owa-application-settings';
import { getItem } from 'owa-local-storage';

export function shouldShadowCallNetCore(
    getApplicationSettingsCallback?: <TGroup extends ApplicationSettingGroup>(
        group: TGroup,
        mailboxInfo?: MailboxInfo,
        dontErrorIfNotInitialized?: boolean
    ) => ApplicationSettings[TGroup],
    mailboxInfo?: MailboxInfo
): boolean {
    try {
        return !!(
            getApplicationSettingsCallback?.(
                'NetCore',
                mailboxInfo,
                true /* dontErrorIfNotInitialized */
            ).shouldShadowCall ??
            JSON.parse(getItem(self, 'applicationSettingOverrides') ?? '')[
                'NetCore.shouldShadowCall'
            ]
        );
    } catch {
        return false;
    }
}
